// extracted by css-extract-rspack-plugin
export default {"wrapper":"SourceCheckbox-module__wrapper--k0beD"};